module.exports = __webpack_public_path__ + "static/media/apartment15.dfb0cb00.jpg";